// Libs
import classNames from 'classnames/bind';
import { Box, Grid2 } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
import { AdditionalInformation, BasicInformation } from '~/components/module/vendors';
import { Loading } from '~/components/common';
// Others
import { useAppDispatch, useAppSelector } from '~/utils/redux/hooks';
import { IQueryParamDetailVendor } from '~/utils/interface/vendors';
import { getDetailVendor } from '~/thunks/vendors/vendorsThunk';
import { TypeVendorDetailEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './InfoVendorTab.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const InfoVendorTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { id: vendorId } = useParams();
  const { isLoading } = useAppSelector((state) => state.vendor);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook

  useEffect(() => {
    if (!vendorId) return;
    const params: IQueryParamDetailVendor = {
      vendorId: vendorId,
      type: TypeVendorDetailEnum.OVERVIEW,
    };
    handleGetDetailVendor(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);
  //#endregion Implement Hook

  //#region Handle Function

  const handleGetDetailVendor = (params: IQueryParamDetailVendor) => {
    dispatch(getDetailVendor(params))
      .unwrap()
      .then((res) => {})
      .catch((err) => {})
      .finally(() => {});
  };
  //#endregion Handle Function

  return (
    <Box id='infoVendorTabComponent' className={cx('container')}>
      <Grid2 container spacing={4}>
        <Grid2 size={6}>
          <BasicInformation />
        </Grid2>

        <Grid2 size={6}>
          <AdditionalInformation />
        </Grid2>
      </Grid2>

      {isLoading && <Loading />}
    </Box>
  );
};

export default InfoVendorTab;
